/* eslint-disable react/require-default-props */
import React from 'react';
import { Container } from './styles';

interface CheckboxProps {
  customClass?: string;
  label: string;
  checked: boolean;
  disabled: boolean;
  handleChange: () => void;
}

const Checkbox = (props: CheckboxProps) => {
  const { customClass = '', label, checked, disabled, handleChange } = props;
  const id = `checkbox-${Math.random()}`;

  return (
    <Container>
      <label htmlFor={id} className={`${customClass} control control-checkbox`}>
        {label}
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={() => {
            handleChange();
          }}
          disabled={disabled}
        />
        <div className="control_indicator" />
      </label>
    </Container>
  );
};

export default Checkbox;
